function pfFormatMoney(amount, format) {
    if (typeof amount === 'string') {
        amount = amount.replace('.', '');
    }

    const moneyFormat = format || this.money_format || '${{amount}}';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function getDefaultValue(value, defaultValue) {
        return value !== undefined ? value : defaultValue;
    }

    function formatNumber(amount, decimals = 2, thousandsSeparator = ',', decimalSeparator = '.') {
        decimals = getDefaultValue(decimals, 2);
        thousandsSeparator = getDefaultValue(thousandsSeparator, ',');
        decimalSeparator = getDefaultValue(decimalSeparator, '.');

        if (isNaN(amount) || amount == null) {
            return '0';
        }

        const formattedAmount = (amount / 100).toFixed(decimals);
        const parts = formattedAmount.split('.');
        const wholePart = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousandsSeparator}`);
        const decimalPart = parts[1] ? decimalSeparator + parts[1] : '';

        return wholePart + decimalPart;
    }

    const placeholderMatch = moneyFormat.match(placeholderRegex);

    if (!placeholderMatch) {
        throw new Error('Invalid format: No valid placeholder found');
    }

    const placeholderType = placeholderMatch[1];
    let formattedAmount = '';

    switch (placeholderType) {
        case 'amount':
            formattedAmount = formatNumber(amount, 2, ',', '.');
            break;
        case 'amount_no_decimals':
            formattedAmount = formatNumber(amount, 0, ',', '.');
            break;
        case 'amount_with_comma_separator':
            formattedAmount = formatNumber(amount, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            formattedAmount = formatNumber(amount, 0, '.', ',');
            break;
        default:
            throw new Error(`Unknown placeholder type: ${placeholderType}`);
    }

    return moneyFormat.replace(placeholderRegex, formattedAmount);
}

function getForm(prodCard) {
    return prodCard.querySelector(`form[action*="/cart/add"]`);
}

function getSelectedSellingPlanId(prodCard) {
    const form = getForm(prodCard);
    const customSellingPlanInput = form?.querySelector('input[name="selling_plan_0"]');
    if(customSellingPlanInput && customSellingPlanInput.value == "onetime") {
        return null
    } 
    const sp = form?.querySelector('input[name="selling_plan"], select[name="selling_plan"]');
    const val = sp?.value;
    return val ? Number(val) : null;
}


function updateCustomPrice() {
    const variantPickerWrapper = document.querySelectorAll("variant-selects");
    variantPickerWrapper.forEach(variantPicker => {
        const countOptions = variantPicker.querySelectorAll('label[data-option-name*="-count"]');
        const variantKeys = variantPicker.variant_map;
        const prodCard = variantPicker.closest(".card") || variantPicker.closest(".product__info-wrapper");

        const currentSellingPlan = getSelectedSellingPlanId(prodCard);

        countOptions.forEach(option => {
            const countAttribute = option.getAttribute("data-option-name");
            const isSoftgel = option.getAttribute("data-is-softgel") == "true";
            const countAttributeNum = parseInt(countAttribute.replace(/[^0-9.,]/g, ''), 10);

            const optionPrice = [...variantKeys].find(([key]) => key.includes(countAttribute))?.[1];

            if (!optionPrice) return console.log("Option price not found");


            let currentOptionPrice;

            if (currentSellingPlan) {
                currentOptionPrice = optionPrice.selling_plan_allocations.find(i => i.selling_plan_id == currentSellingPlan).price;
            } else {
                currentOptionPrice = optionPrice.price;
            }


            const pricePerDose = pfFormatMoney(currentOptionPrice / countAttributeNum);
            const pricePerDoseElm = option.querySelector(".price-per-dose");

            if (!pricePerDoseElm) return console.log("PPD elm not found");

            if (pricePerDoseElm.innerHTML.includes(pricePerDose)) return;

            pricePerDoseElm.innerHTML = `${pricePerDose} <span>${isSoftgel ? 'per softgel' : 'per gummy'}</span>`;
        });

    })
}

function initRechargeDetection() {
    setInterval(updateCustomPrice, 250)
}

document.addEventListener('DOMContentLoaded', () => {
    initRechargeDetection();
    updateCustomPrice();
});